import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import store from './store';
import * as echarts from 'echarts'
import { createI18n } from 'vue-i18n';
import Papa from 'papaparse';

import { vuetifyProTipTap } from './tiptap'; // 引入配置文件


import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'


function globalParseCsvData(csvData) {
    var nodeSourceList = []
    var tableHeadersList = []
    if (!csvData) {
        console.error('CSV data is empty.');
        return;
    }

    // 使用 PapaParse 解析 CSV 数据
    Papa.parse(csvData, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
            var nodeSource = results.data;

            // 生成符合 v-data-table 格式的动态表头
            if (results.meta.fields) {
                var tableHeaders = results.meta.fields.map((field) => ({
                    title: field,    // 表头显示的文本
                    key: field,   // 数据项的字段名
                    align: 'start', // 可选：默认左对齐
                    sortable: true, // 可选：允许排序
                    value: field
                }));
            }
            // console.log('Parsed CSV Data:', nodeSource);
            // console.log('Generated Headers:', tableHeaders);
            nodeSourceList = nodeSource
            tableHeadersList = tableHeaders
        },
        error: (error) => {
            console.error('Error parsing CSV:', error);
        },
    });

    return { "node": nodeSourceList, "header": tableHeadersList }
}

// 定义语言包
const messages = {
    en: {
        message: {
            home: 'Home',
            userDashboard: 'Dashboard',
            profile: 'Operation History',
            changePassword: 'Set New Password',
            forgetPassword: 'Forget Password',
            resetPassword: 'Reset Password',
            changeUsername: 'Change Username',
            changeProfile: 'Change Profile',
            login: 'Login',
            logout: 'Logout',
            register: 'Register',
            languageSwitch: 'Switch Language',
            sendResetLink: "Send Reset Link",
            newPassword: "New Password",
            oldPassword: "Old Password",
            newUsername: "New Username",
            email: "Email",
            detail: "Detail",
            share: "Share",
            password: "Password",
            username: "User Name",
            confirmPassword: "Confirm Password",
            download: "Download",
            delete: "Delete",
            ExposomeX: "ExposomeX",
            Team: "Team",
            Contacts: "Contacts",
            About: "About",
            tutorials: "Tutorials",
            updateHistory: "Update History",
            publication: "Publications",
            community: "Community",
            video: "Video",
            web: "Web",
            r: "Python",
            userStats: "UserStats",
            version: "Version",
            v1: "ExposomeX V1",
            profilePhoto: "Profile photo",
            country: "Country",
            institution: "Institution",
            field: "Field",
            profilePhotoHint: "Supports JPG, PNG, GIF formats, file size up to 1MB",
            close: "Close",
        }
    },
    zh: {
        message: {
            home: '主页',
            userDashboard: '用户仪表板',
            profile: '查看历史记录',
            changePassword: '设置新密码',
            forgetPassword: '忘记密码',
            resetPassword: '重置密码',
            changeUsername: '更改用户名',
            changeProfile: '修改信息',
            login: '登录',
            logout: '登出',
            register: '注册',
            languageSwitch: '切换语言',
            sendResetLink: "发送重置链接",
            newPassword: "新密码",
            oldPassword: "旧密码",
            newUsername: "新用户名",
            email: "邮箱",
            detail: "详情",
            share: "分享",
            password: "密码",
            username: "用户名",
            confirmPassword: "确认密码",
            download: "下载",
            delete: "删除",
            ExposomeX: "Python包",
            Team: "团队",
            Contacts: "联系",
            About: "关于",
            tutorials: "手册",
            updateHistory: "更新历史",
            publication: "发表论文",
            community: "社区",
            video: "视频",
            web: "网页",
            r: "Python",
            userStats: "用户统计",
            version: "版本",
            v1: "ExposomeX 版本1",
            profilePhoto: "头像",
            country: "国家",
            institution: "机构",
            field: "领域",
            profilePhotoHint: "支持 JPG、PNG、GIF 格式，文件大小不超过 1MB",
            close: "关闭",
        }
    }
};

// 创建 i18n 实例
const i18n = createI18n({
    locale: localStorage.getItem('language') || 'en', // 默认语言为英文，如果localStorage中有保存的语言设置则使用它
    fallbackLocale: 'en', // 如果当前语言缺少翻译内容则回退到英文
    messages, // 语言包
});

// 全局抑制 ResizeObserver 错误（这是 Element Plus 和一些 UI 库的已知问题）
// 这个错误不影响功能，只是在开发模式下会显示警告
// 立即阻止 ResizeObserver 错误，防止错误覆盖层闪现
window.addEventListener('error', (e) => {
    if (
        e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
        e.message === 'ResizeObserver loop limit exceeded' ||
        e.message.includes('ResizeObserver')
    ) {
        // 阻止错误传播
        e.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault();

        // 立即隐藏 webpack-dev-server 错误覆盖层
        const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
        if (resizeObserverErr) {
            resizeObserverErr.style.display = 'none';
        }

        return false;
    }
}, true); // 使用捕获阶段，优先级更高

// 监控 DOM 变化，防止错误覆盖层被插入
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            if (node.id === 'webpack-dev-server-client-overlay') {
                node.style.display = 'none';
            }
        });
    });
});

// 开始观察 body 的子节点变化
if (document.body) {
    observer.observe(document.body, { childList: true });
} else {
    document.addEventListener('DOMContentLoaded', () => {
        observer.observe(document.body, { childList: true });
    });
}

// 创建 Vue 应用实例
const app = createApp(App);

app.config.globalProperties.$echarts = echarts
app.config.globalProperties.$globalParseCsvData = globalParseCsvData
// 使用 router, vuetify, store, 和 i18n
app.use(router);
app.use(vuetify);
app.use(store);
app.use(i18n);
app.use(ElementPlus)
app.use(vuetifyProTipTap);
// 挂载应用
app.mount('#app');
